import type { MatchData } from "../../../mocks/sportsSchedule";

interface MatchCardProps {
  match: MatchData;
}

export default function MatchCard({ match }: MatchCardProps) {
  const statusConfig = {
    live: {
      label: "생중계",
      dotColor: "bg-red-500",
      animate: true,
      badgeBg: "bg-red-500/10",
      badgeText: "text-red-500",
    },
    upcoming: {
      label: "예정",
      dotColor: "bg-brand-orange",
      animate: false,
      badgeBg: "bg-brand-orange/10",
      badgeText: "text-brand-orange",
    },
    finished: {
      label: "종료",
      dotColor: "bg-dark-text-muted",
      animate: false,
      badgeBg: "bg-dark-border",
      badgeText: "text-dark-text-muted",
    },
  };

  const config = statusConfig[match.status];

  return (
    <div className="bg-dark-surface border border-dark-border rounded-xl p-4 md:p-5 hover:border-brand-orange transition-all duration-300 group">
      <div className="flex flex-col gap-4">
        {/* Top Row: League + Status + Hot */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-dark-text-muted text-xs bg-dark-bg px-3 py-1 rounded-full">
              {match.league}
            </span>
            {match.isHot && (
              <span className="text-red-500 text-xs font-bold bg-red-500/10 px-3 py-1 rounded-full flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span>
                HOT
              </span>
            )}
          </div>
          <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${config.badgeBg}`}>
            <span className={`w-2 h-2 rounded-full ${config.dotColor} ${config.animate ? "animate-pulse" : ""}`}></span>
            <span className={`text-xs font-bold ${config.badgeText}`}>
              {match.status === "live" && match.minute ? `${match.minute} ${config.label}` : config.label}
            </span>
          </div>
        </div>

        {/* Match Row: Home + Score/Away */}
        <div className="flex items-center gap-4">
          {/* Home Team */}
          <div className="flex-1 flex flex-col items-end gap-1">
            <span className="text-white font-bold text-base md:text-lg text-right">
              {match.home}
            </span>
          </div>

          {/* Score / Time */}
          <div className="flex flex-col items-center gap-1 min-w-[80px]">
            {match.status === "live" && match.homeScore !== undefined && match.awayScore !== undefined ? (
              <div className="flex items-center gap-2">
                <span className="text-white font-bold text-2xl">{match.homeScore}</span>
                <span className="text-dark-text-muted text-lg">-</span>
                <span className="text-white font-bold text-2xl">{match.awayScore}</span>
              </div>
            ) : match.status === "finished" && match.homeScore !== undefined && match.awayScore !== undefined ? (
              <div className="flex items-center gap-2">
                <span className="text-dark-text-muted font-bold text-xl">{match.homeScore}</span>
                <span className="text-dark-text-muted">-</span>
                <span className="text-dark-text-muted font-bold text-xl">{match.awayScore}</span>
              </div>
            ) : (
              <span className="text-brand-orange font-bold text-xl">{match.time}</span>
            )}
            <span className="text-dark-text-muted text-xs">{match.time}</span>
          </div>

          {/* Away Team */}
          <div className="flex-1 flex flex-col items-start gap-1">
            <span className="text-white font-bold text-base md:text-lg text-left">
              {match.away}
            </span>
          </div>
        </div>

        {/* Bottom Row: Channel + Watch Button */}
        <div className="flex items-center justify-between pt-3 border-t border-dark-border">
          <div className="flex items-center gap-2 text-dark-text-muted text-xs">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-tv-line text-sm"></i>
            </span>
            {match.channel}
          </div>
          <a
            href="https://halmae28.com/sports_live_a"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-orange text-xs font-bold hover:text-brand-orange-hover transition-colors flex items-center gap-1"
          >
            중계보기
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}